import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app"

// Add the Firebase products that you want to use
import "firebase/auth"
import "firebase/firestore"

import router from './router'
import store from './store'

import axios from 'axios'
import constants from './constants.js'
import common from './common.js'


Vue.prototype.$axios = axios
Vue.prototype.$constants = constants
Vue.prototype.$common = common


//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
//Import language
import 'froala-editor/js/languages/ja';

//Import third party
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';

//Import plugins
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/js/plugins/file.min';
import 'froala-editor/css/plugins/file.min.css';
import 'froala-editor/js/plugins/inline_class.min';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)


import Buefy from 'buefy'
Vue.use(Buefy, {
  defaultIconPrev: 'angle-left',
  defaultIconNext: 'angle-right',
  defaultIconPack: 'uil',
  customIconPacks: {
    'uil': {
      sizes: {
        'default': 'is-size-2',
        'is-small': 'is-size-3',
        'is-medium': 'is-size-2',
        'is-large': 'is-size-1'
      },
      iconPrefix: 'uil-',
      internalIcons: {
        'check': 'check',
        'information': 'information',
        'check-circle': 'checkmark-circle',
        'alert': 'exclamation',
        'alert-circle': 'exclamation-circle',
        'arrow-up': 'arrow-up',
        'chevron-right': 'angle-right',
        'chevron-left': 'angle-left',
        'chevron-down': 'arrow-down',
        'eye': 'eye',
        'eye-off': 'eye-slash',
        'menu-down': 'angle-down',
        'menu-up': 'angle-up',
        'close-circle': 'times-circle'
      }
    }
  }
})

import '@/assets/sass/customBulma.scss'
import '@/assets/sass/common.sass'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('7d', '/', '', true, 'Lax')

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueHead from 'vue-head'
Vue.use(VueHead, {
  separator: ' | '
})

import DefaultLayout from '@/layout/DefaultLayout.vue'
import PublicLayout from '@/layout/PublicLayout.vue'
import NoneLayout from '@/layout/NoneLayout.vue'
Vue.component('default-layout', DefaultLayout)
Vue.component('public-layout', PublicLayout)
Vue.component('none-layout', NoneLayout)

Vue.config.productionTip = false



const firebaseConfig = {
  apiKey: "AIzaSyCEdedLLxddb2Wm4MLdBN9ipeAxJlHj7-c",
  authDomain: "corteche-media-site.firebaseapp.com",
  databaseURL: "https://corteche-media-site.firebaseio.com",
  projectId: "corteche-media-site",
  storageBucket: "corteche-media-site.appspot.com",
  messagingSenderId: "967945490937",
  appId: "1:967945490937:web:f94c3bcd9c4e7a461ead28",
  measurementId: "G-V2B1ZQF7JW"
};
firebase.initializeApp(firebaseConfig);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// interceptors
axios.interceptors.request.use(request => {

  const token = Vue.$cookies.get('token');
  if (token != null) {
    request.headers.Authorization = `Token ${token}`
  }
  return request
})